// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ffo5568sPpw8B6 {
  width: 100%;
  height: 60px;
  animation: fdgX165rJBxGrx 1.5s infinite;
  border-radius: var(--ds-border-radius-100, 3px);
}
@keyframes fdgX165rJBxGrx {
  0% {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
  100% {
    background-color: var(--ds-skeleton, #091e420f);
  }
}
.a4u_m0c4imcsY_ {
  position: relative;
  box-sizing: border-box;
  width: calc(100% - 2px);
  margin: var(--ds-space-0, 0) auto;
  padding: var(--ds-space-200, 16px);
  overflow: hidden;
  transition: background 0.3s ease;
  border-radius: var(--ds-border-radius-100, 3px);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  text-rendering: geometricPrecision;
}
.GMN4JBOkT3vig6 {
  background: var(--ds-surface-raised, #ffffff);
}
.GMN4JBOkT3vig6 .PCwQogn_671aIm {
  color: var(--ds-text, #172b4d);
}
.GMN4JBOkT3vig6 .wcbAiviXqqpKIf {
  color: var(--ds-text-subtle, #44546f);
}
.GMN4JBOkT3vig6 .ZAW6pQV1x5HgWY svg {
  color: var(--ds-icon-inverse, #ffffff);
}
.GMN4JBOkT3vig6 .C8KkcQEBhwZyHi {
  background: var(--ds-background-discovery-bold, #6e5dc6);
}
.GMN4JBOkT3vig6 .Z4ClxfSsxoxfBm {
  background: var(--ds-background-neutral, #091e420f);
}
.GMN4JBOkT3vig6 .dRPAg5ZA7UAUrR:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
}
.iNBrDDfVTVL1MJ {
  background: var(--ds-background-discovery-bold, #6e5dc6);
}
.iNBrDDfVTVL1MJ .PCwQogn_671aIm {
  color: var(--ds-text-inverse, #ffffff);
}
.iNBrDDfVTVL1MJ .wcbAiviXqqpKIf {
  color: var(--ds-text-inverse, #ffffff);
}
.iNBrDDfVTVL1MJ .ZAW6pQV1x5HgWY svg {
  color: var(--ds-icon-discovery, #8270db);
}
.iNBrDDfVTVL1MJ .C8KkcQEBhwZyHi {
  background: var(--ds-surface-raised, #ffffff);
}
.iNBrDDfVTVL1MJ .Z4ClxfSsxoxfBm {
  background: var(--ds-background-accent-purple-subtle, #9f8fef);
}
.iNBrDDfVTVL1MJ .dRPAg5ZA7UAUrR:hover {
  background: var(--ds-background-accent-purple-subtle, #583f68);
}
.PCwQogn_671aIm {
  margin: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-150, 12px);
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  font-weight: var(--ds-font-weight-semibold, 600);
  letter-spacing: -0.003em;
  line-height: 16px;
}
.wcbAiviXqqpKIf {
  margin-bottom: var(--ds-space-150, 12px);
}
.ZAW6pQV1x5HgWY {
  width: 26px;
  height: 26px;
  padding: var(--ds-space-025, 2px);
}
.ZAW6pQV1x5HgWY svg {
  width: 22px;
  height: 22px;
  line-height: 24px;
}
.C8KkcQEBhwZyHi {
  position: absolute;
  z-index: 2;
  right: var(--ds-space-100, 8px);
  bottom: var(--ds-space-100, 8px);
  width: 26px;
  height: 26px;
  border-radius: var(--ds-border-radius-100, 3px);
}
.Z4ClxfSsxoxfBm {
  position: absolute;
  z-index: 1;
  right: -28px;
  bottom: -64px;
  width: 120px;
  height: 80px;
  transform: rotate(-50deg);
  border-radius: var(--ds-border-radius-300, 12px);
}
.dRPAg5ZA7UAUrR {
  display: flex;
  position: absolute;
  top: var(--ds-space-100, 8px);
  right: var(--ds-space-100, 8px);
  width: 22px;
  height: 22px;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-050, 4px);
  border: 0;
  background: none;
}
.Rso7n4SPOhby47 {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  margin-left: -1px;
  line-height: 14px;
}
`, ""]);
// Exports
export var animation = `ffo5568sPpw8B6`;
export var pulse = `fdgX165rJBxGrx`;
export var upgradePromptFull = `a4u_m0c4imcsY_`;
export var upgradePromptFullLightTheme = `GMN4JBOkT3vig6`;
export var upgradePromptFullHeadline = `PCwQogn_671aIm`;
export var upgradePromptFullContent = `wcbAiviXqqpKIf`;
export var upgradePromptFullIcon = `ZAW6pQV1x5HgWY`;
export var upgradePromptFullIconBackground = `C8KkcQEBhwZyHi`;
export var upgradePromptFullIconClippedBackground = `Z4ClxfSsxoxfBm`;
export var upgradePromptFullCloseButtonWrapper = `dRPAg5ZA7UAUrR`;
export var upgradePromptFullDarkTheme = `iNBrDDfVTVL1MJ`;
export var upgradePromptFullCloseButton = `Rso7n4SPOhby47`;
export default ___CSS_LOADER_EXPORT___;
